import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { updateParkStatus, fetchInvoiceItems } from "../Api/VendorInvoice";
import { Base_URL } from "../url";

import "../Styling/PayrollTheme.css";
import "../Styling/VIMTheme.css";

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "—";

  return Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatSAPDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);

  return (
    d.getFullYear() +
    String(d.getMonth() + 1).padStart(2, "0") +
    String(d.getDate()).padStart(2, "0")
  );
};

const VIMInvoiceGrid = ({ data = [] }) => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(data);
  }, [data]);

  const handleParkStatus = async (guid, type) => {
    try {
      const payload = {
        invoice_Staging_Guid: guid,
        parkStatus: type,
      };

      await updateParkStatus(payload);

      setRows((prev) =>
        prev.map((item) =>
          item.invoice_Staging_Guid === guid
            ? {
                ...item,
                parkStatus: type,
              }
            : item,
        ),
      );
    } catch (err) {
      console.error("Status update failed", err);
    }
  };

  const handleParkAction = async (row, type) => {
    try {
      await handleParkStatus(row.Invoice_Staging_Guid, type);

      const invoiceItems = await fetchInvoiceItems(row.Invoice_Staging_Guid);

      const sapPayload = {
        INVOICE_STAGING_GUID: row.Invoice_Staging_Guid,

        VENDORNAME: row.VendorName,

        INVOICENUMBER: row.InvoiceNumber,

        INVOICEDATE: formatSAPDate(row.InvoiceDate),

        SUBTOTAL: String(row.BaseAmount),

        CGSTRATE: String(row.CGSTRate || ""),

        SGSTRATE: String(row.SGSTRate || ""),

        NETPAYABLE: String(row.NetPayable),

        CUSTOMERNAME: row.ContractTo,

        PARKSTATUS: type,

        INVC_ITEMSet: invoiceItems.map((item) => ({
          HEADERGUID: row.Invoice_Staging_Guid,

          DESCRIPTION: item.Description,

          PRODUCTCODE: item.ProductCode,

          QUANTITY: String(item.Quantity),

          UNITPRICE: String(item.UnitPrice),

          AMOUNT: String(item.Amount),

          TAX: String(item.Tax || ""),
        })),
      };

      console.log(JSON.stringify(sapPayload, null, 2));
      const response = await fetch(
        `${Base_URL}/VIM_Masters/send-to-sap`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sapPayload),
        },
      );

      const result = await response.text();

      console.log(result);
    } catch (err) {
      console.error("SAP Send Failed", err);
    }
  };

  return (
    <div className="vim-container">
      <div className="vim-table-card">
        <div className="vim-table-scroll">
          <table className="vim-table">
            <thead>
              <tr>
                <th>Vendor Name</th>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Base Amount</th>
                <th>CGST Rate</th>
                <th>SGST Rate</th>
                <th>IGST Rate</th>
                <th>CGST Amount</th>
                <th>SGST Amount</th>
                <th>IGST Amount</th>
                <th>Net Payable</th>
                <th>Contract To</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={13} className="vim-empty">
                    No invoices found
                  </td>
                </tr>
              ) : (
                (Array.isArray(rows) ? rows : []).map((row, index) => (
                  <tr key={index}>
                    <td className="vim-vendor">{row.VendorName || "—"}</td>

                    <td className="vim-link">{row.InvoiceNumber || "—"}</td>

                    <td>{formatSAPDate(row.InvoiceDate)}</td>

                    <td className="vim-amount">
                      {formatCurrency(row.BaseAmount)}
                    </td>

                    <td>{row.CGSTRate ?? "—"}</td>

                    <td>{row.SGSTRate ?? "—"}</td>

                    <td>{row.IGSTRate ?? "—"}</td>

                    <td className="vim-amount">
                      {formatCurrency(row.CGSTAmount)}
                    </td>

                    <td className="vim-amount">
                      {formatCurrency(row.SGSTAmount)}
                    </td>

                    <td className="vim-amount">
                      {formatCurrency(row.IGSTAmount)}
                    </td>

                    <td className="vim-amount vim-amount--bold">
                      {formatCurrency(row.NetPayable)}
                    </td>

                    <td>{row.ContractTo || "—"}</td>
                    <td>
                      <div className="vim-actions">
                        <button
                          className="vim-icon-btn"
                          onClick={() =>
                            navigate(`/vim-items/${row.Invoice_Staging_Guid}`)
                          }
                        >
                          ℹ
                        </button>

                        <button
                          disabled={row.ParkStatus === "WITH_PO"}
                          className={
                            row.ParkStatus === "WITH_PO"
                              ? "vim-action-btn vim-action-btn--success"
                              : "vim-action-btn"
                          }
                          onClick={() => handleParkAction(row, "WITH_PO")}
                        >
                          {row.ParkStatus === "WITH_PO"
                            ? "Parked With PO"
                            : "Park With PO"}
                        </button>

                        <button
                          disabled={row.ParkStatus === "WITHOUT_PO"}
                          className={
                            row.ParkStatus === "WITHOUT_PO"
                              ? "vim-action-btn vim-action-btn--danger"
                              : "vim-action-btn"
                          }
                          onClick={() => handleParkAction(row, "WITHOUT_PO")}
                        >
                          {row.ParkStatus === "WITHOUT_PO"
                            ? "Parked Without PO"
                            : "Park Without PO"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VIMInvoiceGrid;
